import * as React from "react";

const SvgText = props => <svg viewBox="0 0 48 53" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.9258 46.9531H19.8125V5.46875H7.64844V13.7656H0.441406V-0.296875H47.9727V13.7656H40.7656V5.46875H26.7031V46.9531H32.1875V53H14.9258V46.9531Z" fill="currentColor" /></svg>;

export default SvgText;